import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { http } from '../../util';

import { imageSetValues } from './propTypeValidations';

import ProductImage from './ProductImage';

const ProductImageList = ({ filterBy, imageSets, limit, productCode }) => {
  const [productViewCodes, setViewCodes] = useState([]);
  const [showImages, setShowImages] = useState(false);

  const renderProductImages = () =>
    productViewCodes.length > 0 ? (
      productViewCodes.map(viewCode => (
        <ProductImage
          key={`${productCode}_${viewCode}`}
          alt={productCode}
          productCode={productCode}
          viewCode={viewCode}
        />
      ))
    ) : (
      <ProductImage alt={productCode} productCode={productCode} />
    );

  const requestAndSetViewCodes = async () => {
    const reducedViewCodes = await imageSets.reduce(async (acc, set) => {
      const accumulator = await acc;
      const response = await http.get(
        import.meta.env.VITE_PRODUCT_IMAGE_URL.concat(`/search?productCode=${productCode}&imageSet=${set}`)
      );

      if (response?.data?.results.length) {
        // Implementation specific to single product code parameter
        const viewCodes = response.data.results[0].assets.map(item => item.metadata.viewCode);
        const filteredViewCodes = typeof filterBy === 'function' ? filterBy(viewCodes) : viewCodes;
        accumulator.push(...filteredViewCodes.slice(0, limit));
      }

      return accumulator;
    }, []);

    setViewCodes(reducedViewCodes);
    // catch unnecessary as ProductImage to be rendered regardless of outcome
  };

  useEffect(() => {
    if (productCode) {
      // Callback not async as effect hook should return nothing or a cleanup function
      (async () => {
        setShowImages(false);
        await requestAndSetViewCodes();
        setShowImages(true);
      })();
    }
  }, [productCode]);

  return <div data-testid='_test_image_container'>{showImages && renderProductImages()}</div>;
};

export default ProductImageList;

ProductImageList.defaultProps = {
  filterBy: undefined,
  imageSets: ['PV'],
  limit: 5
};

ProductImageList.propTypes = {
  filterBy: PropTypes.func,
  imageSets: PropTypes.arrayOf(PropTypes.oneOf(imageSetValues)),
  limit: PropTypes.number,
  productCode: PropTypes.string.isRequired
};
